import { j as l } from "../../modules/index.es3.js";
import { Slot as n } from "../../modules/index.es7.js";
import * as d from "react";
import { cn as t } from "../../utils/styling.es.js";
import { pillVariants as x, pillRemoveButtonVariants as j } from "./Pill.styles.es.js";
import u from "../../modules/index.es26.js";
const N = d.forwardRef(
  ({
    className: m,
    appearance: o,
    variant: s,
    size: i,
    children: a,
    asChild: e = !1,
    onRemove: r,
    ...f
  }, p) => {
    const c = e ? n : "div";
    return /* @__PURE__ */ l.jsxs(
      c,
      {
        className: t(
          x({ appearance: o, variant: s, size: i, className: m }),
          r ? "pr-2" : ""
        ),
        ref: p,
        ...f,
        children: [
          a,
          r && /* @__PURE__ */ l.jsx(
            "button",
            {
              "aria-label": "Remove item",
              className: t(
                j({ appearance: o, variant: s }),
                "ml-2"
              ),
              onClick: r,
              children: /* @__PURE__ */ l.jsx(u, { className: "w-3" })
            }
          )
        ]
      }
    );
  }
);
N.displayName = "Pill";
export {
  N as default
};
//# sourceMappingURL=Pill.es.js.map
